import React from 'react';
import { motion } from 'framer-motion';
import esocialImg from '../../assets/images/esocial.png';
import esocial1Img from '../../assets/images/esocial1.png';
import { WHATSAPP_LINKS } from '../../config/whatsapp';

const esocialCards = [
  {
    id: 1,
    title: 'S-2210',
    description: 'Comunicação de Acidente de Trabalho. Enviamos as informações sobre acidentes de trabalho à Previdência Social.',
  },
  {
    id: 2,
    title: 'S-2220',
    description: 'Monitoramento da Saúde do Trabalhador. Gerenciamos os exames médicos ocupacionais dos seus colaboradores.',
  },
  {
    id: 3,
    title: 'S-2240',
    description: 'Condições Ambientais do Trabalho. Elaboramos e enviamos as informações sobre os riscos ambientais aos quais os trabalhadores estão expostos.',
  },
];

const ESocial = () => {
  return (
    <section id="esocial" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">O e-Social de sua empresa está em dia?</h2>
          <div className="w-20 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <div className="flex justify-center mb-8">
            <img 
              src={esocialImg} 
              alt="eSocial Logo" 
              className="h-32 md:h-72 rounded-xl"
            />
          </div>
          <p className="text-gray-700 max-w-3xl mx-auto text-lg">
            O eSocial é um sistema de registro elaborado pelo governo federal para facilitar a administração de informações relativas aos trabalhadores. Fique em conformidade com a legislação e evite multas.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {esocialCards.map((card) => (
            <motion.div
              key={card.id}
              className="bg-emerald-700 text-white p-8 rounded-lg shadow-lg"
              whileHover={{ y: -5 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="text-2xl font-bold mb-4 text-white drop-shadow-md">{card.title}</h3>
              <p className="text-white/90 text-lg leading-relaxed">{card.description}</p>
            </motion.div>
          ))}
        </div>
        
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/3 mb-6 md:mb-0">
              <img 
                src={esocial1Img} 
                alt="eSocial Compliance" 
                className="rounded-lg max-w-full h-auto shadow-md"
              />
            </div>
            <div className="md:w-2/3 md:pl-12">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Fique tranquilo com o eSocial</h3>
              <p className="text-gray-700 mb-4 text-lg leading-relaxed">
                Nossa equipe especializada cuida de todo o processo de adequação e envio das informações exigidas pelo eSocial, garantindo que sua empresa esteja sempre em conformidade com a legislação.
              </p>
              <p className="text-gray-700 mb-6 text-lg leading-relaxed">
                Oferecemos consultoria completa para implementação, adequação e manutenção do eSocial, com foco nos eventos de Segurança e Saúde no Trabalho (SST).
              </p>
              <motion.a 
                href={WHATSAPP_LINKS.focoseg} 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 px-8 rounded-full shadow-lg transition duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <span>Solicite uma avaliação</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ESocial;